import React, { Component } from "react";
import { Alert, Row, Col, Button, FormGroup, Label, Input, Spinner} from 'reactstrap';

export class YangguangRedirect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: "",
            loading: true,
            code: "",
            tenantId: - 1,
            showError: false,
            showErrorMsg: "",
        }
    };

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const url = urlParams.get("url");
        if (!url) {
            this.setState({ code: "500", message: "跳转失败，请联系管理员。", loading: false });
            return;
        }
        window.open(decodeURI(url));
    };

    showError = (text) => {
        this.setState({ showErrorMsg: text, showError: true })
    }

    errDismiss = () => {
        const isErrorShowing = this.state.showError;
        if (isErrorShowing) {
            this.setState({ showError: false })
        }
        else {
            this.setState({ showError: true })
        }
    };

    renderHtml = () => {
        return (
            <Col sm="12" md={{ size: 8, offset: 2 }} style={{ marginTop: '50px' }}>
                <Alert color="light">
                    <h3 className="alert-heading">跳转中...</h3>
                </Alert>
            </Col>
        );
    }

    render() {
        let contents = "";
        contents = this.renderHtml();

        return (
            <div>{contents}</div>
        );
    }
}